import { MODULE_SERVICE_NAME } from '../app/amm-share/constants';
import { Environment } from '../app/amm-share/models';

const serviceConfig = {
  protocal: 'https://',
  host: 'shoppal.com',//TODO: need to replace with uat server url
  port: '',
};
export const environment: Environment = {
  production: true,
  backendHost: 'https://shoppal.com', //TODO: need to replace with uat server url
  enableAnonymous: true,
  sseServer: 'https://shoppal.com/crm/sse/subscribe', //TODO: need to replace with uat server url
  stripePK: 'pk_test_51Q2hUhRwtrBlDjxv7VUVhDYbE79xl6LhodRgNffdqsum5xiD5Vb5MUi4BU5oKMCCpMXqIcbAXyc36K5XTPbRFBlO001BEjNfNz',
  googleSigninClientId: '360412492168-rnrkem7cua7ft7u1nf5isn96jp5ibbvj.apps.googleusercontent.com',
  jwtExpireCheckInterval: 60*1000, // Check JWT expiry for every 1 minutes 

  moduleService: {
    [MODULE_SERVICE_NAME.RBAC]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.API_CATALOG]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.CATALOG]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.SHOPPINGCART]: {
      ...serviceConfig,
    }, 
    [MODULE_SERVICE_NAME.API_SHOPPINGCART]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.MERCHANT]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.BMS]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.CRM]: {
      ...serviceConfig,
    },
    [MODULE_SERVICE_NAME.GLOBALDATA]: {
      ...serviceConfig,
    },
  },
};
